"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_VALUE_FORMAT = exports.DATE_TIME_SEPARATORS = void 0;
exports.DATE_TIME_SEPARATORS = [
    "at",
    "T",
    " at",
    " at ",
    "at ",
    " T",
    "T ",
    " T ",
    " ",
];
exports.TIME_VALUE_FORMAT = "HH:mm:ss";
